module.exports = __webpack_public_path__ + "img/map.2c8cbae0.png";